import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FaHeart, FaCamera, FaTree, FaList, FaQuoteLeft, FaUsers } from 'react-icons/fa';
import SakuraBackground from '../components/SakuraBackground';
import './MainPage.css';

const MainPage = () => {
  // 恋爱开始时间（请根据实际情况修改这个时间）
  const startDate = new Date('2023-10-13T01:00:00');
  
  // 状态管理：当前时间差
  const [timeDiff, setTimeDiff] = useState({ days: 0, hours: 0 });
  
  // 计算时间差的函数
  const calculateTimeDiff = () => {
    const now = new Date();
    const diffTime = Math.abs(now - startDate);
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    const diffHours = Math.floor((diffTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    
    setTimeDiff({ days: diffDays, hours: diffHours });
  };
  
  // 组件挂载时计算时间差，并设置定时器每分钟更新
  useEffect(() => {
    calculateTimeDiff(); // 初始计算
    const timer = setInterval(calculateTimeDiff, 60000); // 每分钟更新一次
    
    return () => clearInterval(timer); // 清理定时器
  }, []);

  const menuItems = [
    { 
      path: '/blessing', 
      title: '祝福语', 
      icon: <FaQuoteLeft />, 
      description: '温暖的话语，传递爱意',
      color: 'rgba(255, 182, 193, 0.8)'
    },
    { 
      path: '/memories', 
      title: '点点滴滴', 
      icon: <FaHeart />, 
      description: '记录我们的美好时光',
      color: 'rgba(255, 192, 203, 0.8)'
    },
    { 
      path: '/love-list', 
      title: '爱情清单', 
      icon: <FaList />, 
      description: '我们想要一起做的事',
      color: 'rgba(255, 105, 180, 0.8)'
    },
    { 
      path: '/album', 
      title: '时光相册', 
      icon: <FaCamera />, 
      description: '珍藏每一个瞬间',
      color: 'rgba(255, 20, 147, 0.8)'
    },
    { 
      path: '/love-tree', 
      title: '爱情树', 
      icon: <FaTree />, 
      description: '见证我们的成长',
      color: 'rgba(220, 20, 60, 0.8)'
    },
    { 
      path: '/about', 
      title: '关于我们', 
      icon: <FaUsers />, 
      description: '我们的故事开始',
      color: 'rgba(199, 21, 133, 0.8)'
    }
  ];

  return (
    <motion.div
      className="main-page"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.8 }}
    >
      {/* 樱花飘落背景 */}
      <SakuraBackground />
      
      {/* 上半部分 - 背景图片区域 */}
      <div className="top-section">
        <motion.div
          className="hero-section"
          initial={{ y: -50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.8 }}
        >
          <div className="avatars-container">
            <div className="avatar-left">
              <div className="avatar male-avatar">
                <img src="/maomao.jpeg" alt="毛毛" className="avatar-image" />
              </div>
              <span className="avatar-label">毛毛</span>
            </div>
            
            <div className="love-counter">
              <div className="love-days">
                今天，是我们在一起的第<span className="highlight-number">{timeDiff.days}</span>天<span className="highlight-number">{timeDiff.hours}</span>小时
              </div>
              <p className="main-subtitle">
                在这里，记录属于我们的每一个美好瞬间
              </p>
            </div>
            
            <div className="avatar-right">
              <div className="avatar female-avatar">
                <img src="/dandan.jpeg" alt="蛋蛋" className="avatar-image" />
              </div>
              <span className="avatar-label">蛋蛋</span>
            </div>
          </div>
          
          <div className="love-quote">
            "爱情是生命的盐，没有它，一切都失去了味道"
          </div>
        </motion.div>
      </div>

      {/* 波浪线分割 */}
      <div className="wave-divider">
        <div className="wave-animation">
          <svg viewBox="0 0 600 200" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
            <defs>
              <linearGradient id="waveGradient" x1="0%" y1="100%" x2="0%" y2="0%">
                <stop offset="0%" style={{stopColor: 'rgba(255, 240, 245, 0.4)', stopOpacity: 1}} />
                <stop offset="25%" style={{stopColor: 'rgba(255, 228, 235, 0.5)', stopOpacity: 1}} />
                <stop offset="60%" style={{stopColor: 'rgba(255, 205, 215, 0.7)', stopOpacity: 1}} />
                <stop offset="100%" style={{stopColor: 'rgba(255, 182, 193, 0.8)', stopOpacity: 1}} />
              </linearGradient>
            </defs>
            <path d="M0,100 Q150,50 300,100 T600,100 L600,200 L0,200 Z" fill="url(#waveGradient)"/>
          </svg>
          <svg viewBox="0 0 600 200" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
            <defs>
              <linearGradient id="waveGradient2" x1="0%" y1="100%" x2="0%" y2="0%">
                <stop offset="0%" style={{stopColor: 'rgba(255, 240, 245, 0.4)', stopOpacity: 1}} />
                <stop offset="25%" style={{stopColor: 'rgba(255, 228, 235, 0.5)', stopOpacity: 1}} />
                <stop offset="60%" style={{stopColor: 'rgba(255, 205, 215, 0.7)', stopOpacity: 1}} />
                <stop offset="100%" style={{stopColor: 'rgba(255, 182, 193, 0.8)', stopOpacity: 1}} />
              </linearGradient>
            </defs>
            <path d="M0,100 Q150,50 300,100 T600,100 L600,200 L0,200 Z" fill="url(#waveGradient2)"/>
          </svg>
          <svg viewBox="0 0 600 200" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
            <defs>
              <linearGradient id="waveGradient3" x1="0%" y1="100%" x2="0%" y2="0%">
                <stop offset="0%" style={{stopColor: 'rgba(255, 240, 245, 0.4)', stopOpacity: 1}} />
                <stop offset="25%" style={{stopColor: 'rgba(255, 228, 235, 0.5)', stopOpacity: 1}} />
                <stop offset="60%" style={{stopColor: 'rgba(255, 205, 215, 0.7)', stopOpacity: 1}} />
                <stop offset="100%" style={{stopColor: 'rgba(255, 182, 193, 0.8)', stopOpacity: 1}} />
              </linearGradient>
            </defs>
            <path d="M0,100 Q150,50 300,100 T600,100 L600,200 L0,200 Z" fill="url(#waveGradient3)"/>
          </svg>
          <svg viewBox="0 0 600 200" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
            <defs>
              <linearGradient id="waveGradient4" x1="0%" y1="100%" x2="0%" y2="0%">
                <stop offset="0%" style={{stopColor: 'rgba(255, 240, 245, 0.4)', stopOpacity: 1}} />
                <stop offset="25%" style={{stopColor: 'rgba(255, 228, 235, 0.5)', stopOpacity: 1}} />
                <stop offset="60%" style={{stopColor: 'rgba(255, 205, 215, 0.7)', stopOpacity: 1}} />
                <stop offset="100%" style={{stopColor: 'rgba(255, 182, 193, 0.8)', stopOpacity: 1}} />
              </linearGradient>
            </defs>
            <path d="M0,100 Q150,50 300,100 T600,100 L600,200 L0,200 Z" fill="url(#waveGradient4)"/>
          </svg>
        </div>
      </div>

      {/* 下半部分 - 粉红色背景区域 */}
      <div className="bottom-section">
        <div className="main-content">
          <motion.div
            className="menu-grid"
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.4, duration: 0.8 }}
          >
            {/* 第一排 - 4个按钮 */}
            <div className="menu-row first-row">
              {menuItems.slice(0, 4).map((item, index) => (
                <motion.div
                  key={item.path}
                  initial={{ opacity: 0, y: 30 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.6 + index * 0.1, duration: 0.6 }}
                  whileHover={{ scale: 1.03, y: -5 }}
                  whileTap={{ scale: 0.97 }}
                >
                  <Link to={item.path} className="menu-item">
                    <div className="menu-icon" style={{ color: item.color }}>
                      {item.icon}
                    </div>
                    <div className="menu-text">
                      <h3 className="menu-title">{item.title}</h3>
                      <p className="menu-description">{item.description}</p>
                    </div>
                    <div className="menu-arrow">→</div>
                  </Link>
                </motion.div>
              ))}
            </div>
            
            {/* 第二排 - 2个按钮 */}
            <div className="menu-row second-row">
              {menuItems.slice(4, 6).map((item, index) => (
                <motion.div
                  key={item.path}
                  initial={{ opacity: 0, y: 30 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 1.0 + index * 0.1, duration: 0.6 }}
                  whileHover={{ scale: 1.03, y: -5 }}
                  whileTap={{ scale: 0.97 }}
                >
                  <Link to={item.path} className="menu-item">
                    <div className="menu-icon" style={{ color: item.color }}>
                      {item.icon}
                    </div>
                    <div className="menu-text">
                      <h3 className="menu-title">{item.title}</h3>
                      <p className="menu-description">{item.description}</p>
                    </div>
                    <div className="menu-arrow">→</div>
                  </Link>
                </motion.div>
              ))}
            </div>
          </motion.div>

          <motion.div
            className="footer-message"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1.2, duration: 0.8 }}
          >
            <p>💝 愿我们的爱情如樱花般美丽，如音乐般动听 💝</p>
          </motion.div>
        </div>
      </div>
    </motion.div>
  );
};

export default MainPage;


